'use client'

import React, { JSX } from 'react'
import createWidget from '@/widgets/create-widget'
import { PhotoIcon } from '@heroicons/react/24/solid'
import MobileAdStripSchema, { MobileAdStripProps, MobileAdStripDefaultValues } from './schema'
import MobileAdStrip from '@/components/RevampedLanding/MobileAdStrip'

export function MobileAdStripWidget(props: MobileAdStripProps) {
  const { mobileAdStripSection } = props
  // Replace with actual MobileAdStrip component import and usage
  return <MobileAdStrip mobileAdStripData={mobileAdStripSection} />
}

export default createWidget<MobileAdStripProps>({
  formType: MobileAdStripSchema,
  render(props): JSX.Element {
    return <MobileAdStripWidget {...props} />
  },
  id: 'Landing.Page.MobileAdStrip',
  name: 'Landing Ad Strip',
  icon: <PhotoIcon className='w-10 h-10' />,
  defaultProps: MobileAdStripDefaultValues,
})
